<template>
 <!-- 调薪类型 -->
  <div>
    <div style="font-size:20px;float:left;margin:40px;font-weight:600">调薪类型</div>
    <!-- 主体 -->
    <div style="height:750px;background-color:white;margin:75px 40px 0 40px">
      <!-- 查询框 -->
      <div style="margin-left:3%">
        <div style="height:40px"></div>
        <span>调薪类型 </span>
        <el-input v-model="condition.data" placeholder="请输入内容" style="width:180px"></el-input>

        <!-- 按钮 -->
        <div style="display:inline-block;margin-left:20px">
          <el-button type="goon" @click="Find">查询</el-button>
          <el-button type="goon" @click="AddFrom">新增</el-button>
        </div>
      </div>

      <!-- 表格 -->
      <div style="margin:30px 3% 0 3%">
        <el-row>
          <el-table
          :header-cell-style="{background:'#F0F0F0',color:'#000000'}" height="574px"
          :row-class-name="tableRowClassName"
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="handleSelectionChange">
          <el-table-column
            type="selection"
            width="55">
          </el-table-column>
          <el-table-column label="序号">
            <template slot-scope="scope_1">
              {{scope_1.$index + 1}}
            </template>
          </el-table-column>
          <el-table-column
            prop="data" align="center"
            label="调薪类型">
          </el-table-column>
		  <el-table-column align="center" label="调薪类别">
		      <template slot-scope="scope">
		          {{scope.row.spare5 == '1' ? '涨薪' : '降薪'}}
		      </template>
		  </el-table-column>
          <el-table-column
            prop="create_time" align="center"
            label="生成时间">
          </el-table-column>
          <el-table-column
            align="center"
            label="操作" >
            <template slot-scope="scope">
              <img src="../../assets/编辑.png" @click="UpdateFrom(scope.row)">
              <img src="../../assets/删除.png" @click="Del(scope.row.id)" style="margin-left: 10px"/>
            </template>
          </el-table-column>
        </el-table>
        </el-row>

        <el-row style="margin-top: 10px; text-align: center;">
          <el-pagination background @current-change="handleCurrentChange" :page-size="page_size"
            layout=" prev, pager, next, jumper" :total="total">
          </el-pagination>
        </el-row>
      </div>
      
    </div>

            <!-- 详情 -->
        <div>
            <el-dialog :title="from.id == null || from.id == '' ? '添加调薪类型' : '修改调薪类型'" :visible.sync="dialogVisible" width="30%" :close-on-click-modal="false"
                :center="true">

                <el-form :model="from" :rules="rules" ref="from" style="padding: 0 10%;" label-width="110px">
                    <el-form-item label="调薪类型名称" prop="data">
                        <el-input v-model="from.data" placeholder="请输入调薪类型名称" style="width: 100%;"></el-input>
                    </el-form-item>
					<el-form-item label="调薪类别" prop="spare5">
					    <el-radio v-model="from.spare5" label="1">涨薪</el-radio>
					    <el-radio v-model="from.spare5" label="0">降薪</el-radio>
					</el-form-item>
                    <el-form-item style="text-align: center;" label-width="0px">
                        <el-button type="primary" @click="Add" v-show="from.id == null || from.id == ''"
                            style="width: 30%; background-color: #006E4B; border: 1px solid #006E4B;">保存</el-button>
                        <el-button type="primary" @click="Update" v-show="from.id != null && from.id != ''"
                            style="width: 30%; background-color: #006E4B; border: 1px solid #006E4B;">修改</el-button>
                    </el-form-item>
                </el-form>

            </el-dialog>
        </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      //列表相关
      page_num: 1,
      page_size: 10,
      total: 0,
      tableData: [],

      //条件
      condition: {
      data: "",
      },

      //复选框ids
      ids: [],

      //页面相关
      dialogVisible: false,

      //表单数据
      from: {
        id: "",
        data: "",
		spare5:"",
      },

      //表单验证
      rules: {
        data: [{
          required: true,
          message: '请输入调薪类型名称！',
          trigger: 'blur'
        }],
		spare5: [{
		  required: true,
		  message: '请选择调薪类型！',
		  trigger: 'blur'
		}],
      }
    }
  },
  methods: {
    // 全选
    handleSelectionChange(val) {
      this.ids = [];
      e.forEach(item => {
      this.ids.push(item.id);
      })
    },
    //添加页面
    AddFrom() {
      this.trash();
      this.dialogVisible = true;
    },
    //添加操作
    Add() {
        this.$refs["from"].validate(async (valid) => {
            if (valid) {
                var url = "dictionaries/add";
                var record = {
                    data_name: "调薪类型",
                    data: this.from.data,
					spare5: this.from.spare5,
                    data_grouping: "change_salary"
                };
                var data = await this.$globals.AxiosPost(url, record);
                if (data === "-2000") {
                    this.$message.error("服务器未响应！请稍后重试");
                } else {
                    var code = data.code;
                    var data = data.data;
                    if (code === '200') {
                        this.$message.success(data);
                        this.dialogVisible = false;
                        this.trash();
                        this.Find();
                    } else {
                        this.$message.warning(data);
                    }
                }
            }
        });
    },
    //编辑页面
    UpdateFrom(e) {
        this.from.id = e.id;
        this.from.data = e.data;
		this.from.spare5 = e.spare5;
        this.dialogVisible = true;
    },
    //编辑操作
    Update() {
        this.$refs["from"].validate(async (valid) => {
            if (valid) {
                var url = "dictionaries/modify";
                var record = {
                    id: this.from.id,
                    data_name: "调薪类型",
                    data: this.from.data,
					spare5: this.from.spare5,
                    data_grouping: "change_salary"
                };
                var data = await this.$globals.AxiosPost(url, record);
                if (data === "-2000") {
                    this.$message.error("服务器未响应！请稍后重试");
                } else {
                    var code = data.code;
                    var data = data.data;
                    if (code === '200') {
                        this.$message.success(data);
                        this.dialogVisible = false;
                        this.trash();
                        this.Find();
                    } else {
                        this.$message.warning(data);
                    }
                }
            }
        });
    },
    //删除
    async Del(e) {
        var url = "dictionaries/del";
        var record = {
            ids: [e]
        };
        var data = await this.$globals.AxiosPost(url, record);
        if (data === "-2000") {
            this.$message.error("服务器未响应！请稍后重试");
        } else {
            var code = data.code;
            var data = data.data;
            if (code === '200') {
                this.$message.success(data);
                this.dialogVisible = false;
                this.trash();
                this.Find();
            } else {
                this.$message.warning(data);
            }
        }
    },
    //分页
    handleCurrentChange(val) {
        this.page_num = val;
        this.Find();
    },
    //查询
    async Find() {
        var url = "dictionaries/find";
        var record = {
            page_num: this.page_num,
            page_size: this.page_size,
            data_grouping: "change_salary",
            data: this.condition.data
        };
        var data = await this.$globals.AxiosPost(url, record);
        if (data === "-2000") {
            this.$message.error("服务器未响应！请稍后重试");
        } else {
            var code = data.code;
            var data = data.data;
            if (code === '200') {
                this.tableData = data.list;
                this.total = data.total;
            } else {
                this.$message.warning("请求失败！请稍后重试");
            }
        }
    },
    //清除数据
    trash() {
        this.from.data = "";
        this.from.id = "";
		this.from.spare5 = "";
    }
  },
  created() {
            this.Find();
        }
}
</script>

<style>
.el-button--goon:focus,
.el-button--goon:hover {
  background: #006E4B;
  color: #fff;
}
.el-button--goon {
  color: #FFF;
  background-color: #006E4B;
  width: 85px;
}
.el-table .warning-row {
  background: oldlace;
}
.el-table .success-row {
  background: #f0f9eb;
}
</style>


// WEBPACK FOOTER //
// change_salary.vue?37c68a8a